import React, { PropsWithChildren, useState } from "react"
import { styled } from "../stitches.config";


interface IButton {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
}

const CircleButton: React.FC<PropsWithChildren<IButton>> = ({ onClick, children, className, disabled = false }) => {
  return (<Button type="button"
    disabled={disabled}
    className={`circleButton learn-more ${className}`}
    onClick={onClick}>
    <span className="circle" aria-hidden="true">
      <span className="icon arrow"></span>
    </span>
    <span className="button-text">{children}</span>
  </Button>
  )
};

CircleButton.toString = ()=> '.circleButton';

const Button = styled("button", {
  margin: "10px 30px",
  position: "relative",
  display: "inline-block",
  cursor: "pointer",
  outline: "none",
  border: "0",
  verticalAlign: "middle",
  textDecoration: "none",
  background: "transparent",
  padding: "0",
  fontFamily: "inherit",
  fontSize: "1em",
  "&.learn-more": {
    width: "12em",
    height: "auto",
    ".circle": {
      transition: "all 0.45s cubic-bezier(0.65,0,.076,1)",
      position: "relative",
      display: "block",
      margin: "0",
      width: "3em",
      height: "3em",
      background: "#fff",
      border: "2px solid",
      borderColor: "$primary",
      borderRadius: "1.625em",
      ".icon": {
        transition: "all 0.45s cubic-bezier(0.65,0,.076,1)",
        position: "absolute",
        top: "0",
        bottom: "0",
        margin: "auto",
        background: "#272424",
        "&.arrow": {
          transition: "all 0.45s cubic-bezier(0.65,0,.076,1)",
          left: "0.525em",
          width: "1.125em",
          height: "0.125em",
          background: "none",
          "&:before": {
            position: "absolute",
            content: "",
            top: "-0.25em",
            right: "0.0625em",
            width: "0.625em",
            height: "0.625em",
            borderTop: "0.125em solid #272424",
            borderRight: "0.125em solid #272424",
            transform: "rotate(45deg)"
          }
        }
      }
    },
    ".button-text": {
      transition: "all 0.45s cubic-bezier(0.65,0,.076,1)",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "0.75em 0",
      margin: "0 0 0 1.85em",
      color: "#272424",
      fontWeight: 500,
      lineHeight: 1.6,
      textAlign: "center",
      textTransform: "uppercase"
    }
  },
  "&:hover": {
    ".circle": {
      width: "100%",
      backgroundcolor: "$primary",
      ".icon": {
        "&.arrow": {
          background: "#272424",
          transform: "translate(1rem, 0)"
        }
      }
    }
  }
});

export default CircleButton